import React, { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import LandingHeader from './common/LandingHeader';
import LandingFooter from './common/LandingFooter';
import './LandingPage.css';

const TermsAndConditions = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page">
      <LandingHeader />

      <section className="legal-section">
        <div className="landing-container">
          <div className="legal-content">
            <h1>{t('legal.termsAndConditionsTitle')}</h1>
            <p className="legal-last-updated">{t('legal.lastUpdated')}: January 2025</p>

            <h2>1. {t('legal.terms.section1Title')}</h2>
            <p>{t('legal.terms.section1Content')}</p>

            <h2>2. {t('legal.terms.section2Title')}</h2>
            <p>{t('legal.terms.section2Content')}</p>

            <h2>3. {t('legal.terms.section3Title')}</h2>
            <p>{t('legal.terms.section3Content')}</p>

            <h2>4. {t('legal.terms.section4Title')}</h2>
            <p>{t('legal.terms.section4Content')}</p>

            <h2>5. {t('legal.terms.section5Title')}</h2>
            <p>{t('legal.terms.section5Content')}</p>

            <h2>6. {t('legal.terms.section6Title')}</h2>
            <p>{t('legal.terms.section6Content')}</p>

            <h2>7. {t('legal.terms.section7Title')}</h2>
            <p>{t('legal.terms.section7Content')}</p>

            <h2>8. {t('legal.terms.section8Title')}</h2>
            <p>{t('legal.terms.section8Content')}</p>

            <h2>9. {t('legal.terms.section9Title')}</h2>
            <p>{t('legal.terms.section9Content')}</p>

            <h2>10. {t('legal.terms.section10Title')}</h2>
            <p>{t('legal.terms.section10Content')}</p>
          </div>
        </div>
      </section>

      <LandingFooter />
    </div>
  );
};

export default TermsAndConditions;

